export function capeVrValidationMessages(errors = {}, t = value => value) {
  errors = errors || {};
  return [
    errors.standardVas && t("cape_vr_error_complete_scales"),
    errors.customVas && t("cape_vr_error_custom_scale"),
    (errors.categories || errors.inconsistencies === "required") &&
      t("cape_vr_error_categories"),
    errors.inconsistencies === "incomplete" &&
      t("cape_vr_error_inconsistencies"),
    errors.otherInstability && t("cape_vr_error_other_instability"),
    errors.otherAdditionalFeature && t("cape_vr_error_other_feature"),
    errors.taskProvenance && t("cape_vr_error_task_provenance"),
  ].filter(Boolean);
}

export function CapeVrValidationSummary({ errors, t }) {
  const messages = capeVrValidationMessages(errors, t);
  if (!messages.length) return null;

  return (
    <div className="warning-message capev-validation-alert" role="alert">
      <div className="capev-validation-alert__content">
        <span>{t("cape_vr_validation_summary")}</span>
        <ul>{messages.map(message => <li key={message}>{message}</li>)}</ul>
      </div>
    </div>
  );
}
